var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEventBattery({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 51.265,
    height: 43.313,
    viewBox: "0 0 51.265 43.313",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-battery-1713990",
    transform: "translate(-18.596 -0.003)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3688",
    "data-name": "Path 3688",
    d: "M68.094,7.958V40.667a2.656,2.656,0,0,1-2.657,2.649H23.02a2.652,2.652,0,0,1-2.657-2.649V7.958H19.48a.884.884,0,1,1,0-1.768h49.5a.884.884,0,1,1,0,1.768Zm-45.965,0V40.667a.884.884,0,0,0,.89.882H65.436a.888.888,0,0,0,.89-.882V7.958ZM32.735,23.869l0-2.652a.884.884,0,1,1,1.768,0v2.651h2.649a.884.884,0,0,1,0,1.768H34.5v2.652a.884.884,0,1,1-1.768,0l0-2.651H30.085a.884.884,0,0,1,0-1.768ZM51.3,25.637a.884.884,0,1,1,0-1.768h7.068a.884.884,0,0,1,0,1.768Zm0-23.866A.884.884,0,1,1,51.3,0h7.068a.884.884,0,1,1,0,1.768Zm-21.215,0a.884.884,0,1,1,0-1.768h7.068a.884.884,0,1,1,0,1.768Z",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventBattery);
export default __webpack_public_path__ + "static/media/eventBattery.28db961d89215d91b2e314d8f40cd54f.svg";
export { ForwardRef as ReactComponent };